import { h } from 'preact'

const CircleTimesIcon = () => {
    return (
        <svg className='incorrect-answer' fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="9" stroke="#1D1D1D" stroke-width="2"/>
            <path d="m9 9 6 6M9 15l6-6" stroke="#1D1D1D" stroke-width="2" stroke-linecap="round"/>
        </svg>
    )
}

export default CircleTimesIcon